import * as Yup from 'yup'

export const ratingComplianceRuleValidationSchema = Yup.object().shape({
  rating: Yup.string().required(),
  ratingType: Yup.string().required(),
  maxLimit: Yup.number().required(),
})
